import { FC } from 'react'
import styles from 'components/features/creditCard/creditCardPage/Rewards/Rewards.styl'
import { formatUSCurrency } from 'helpers/formatHelpers'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { rewardSummarySelector } from 'selectors/bountySelectors'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { rewardsSummaryGuard } from 'components/features/rewards/rewardsPane/guards/rewardsSummaryGuard'
import { LabeledElement } from 'components/atoms/LabeledElement/LabeledElement'

type RewardsProps = {
}

export const Rewards: FC<RewardsProps> = (props) => {
  const isSummaryLoaded = useSimpleGuard(rewardsSummaryGuard, props, 'RewardsPageRewardsSummary', { fixPropsCheck: true })
  const rewardSummary = useStoreSelector(rewardSummarySelector)

  if (!isSummaryLoaded || !rewardSummary) {
    return (
      <LoadingOverlay />
    )
  }

  const totalRewards = rewardSummary.usdBalance + rewardSummary.cryptoBalance

  return (
    <div className={ styles.rewards }>
      <LabeledElement
        label='Rewards Balance'
        element={ formatUSCurrency(totalRewards, 'penny') }
        vertical
        verticallyCenter
        theme='rewards'

      />
      <div className={ styles.actions }>
        <NavigationLink to='opportunities' className={ styles.primaryAction }>
          <Button
            text='Earn More Rewards'
            style='hollow'
            size='small'
            fullWidth
          />
        </NavigationLink>
        <NavigationLink to='rewards'>
          <Button
            text='Learn more about your rewards'
            style='textOnlyBig'
            size='tiny'
            fullWidth
          />
        </NavigationLink>
      </div>
    </div>
  )
}
